import createTxpConfiguration from './createTxpConfiguration';
import getTxpLocation from './getTxpLocation';
import { populateCalendarFormImages } from 'owa-txp/lib/utils/view/populateImages';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { createCalendarFormStyle } from 'owa-txp/lib/utils/view/createTxpStyle';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import CardRole from 'txp-data/lib/schema/innerSchema/CardRole';

export default function createCalendarReadFormTxpConfiguration(
    isInvoiceSupported: boolean,
    isServiceReservationSupported: boolean,
    entityNamesMap: number,
    txpLocation: EnhancedLocation,
    colorScheme: ColorScheme,
    styles: any
): TxpConfiguration {
    let txpConf = createTxpConfiguration(
        isInvoiceSupported,
        entityNamesMap,
        false, // Action buttons should not be visible in calendar read form
        isServiceReservationSupported,
        CardRole.Primary,
        false, // isEditableCardEnabled is disable for calendar
        null, // no action callbacks required
        null, // no action callbacks required
        null // no action callbacks required
    );

    const txpImages = populateCalendarFormImages(colorScheme);
    txpConf.txpImages = txpImages;
    txpConf.txpImages.packageBaseUrl = getPackageBaseUrl;
    txpConf.getLocationControl = (showFullAddress: boolean) =>
        getTxpLocation(
            txpLocation,
            showFullAddress,
            txpImages,
            createCalendarFormStyle(colorScheme, styles)
        );
    return txpConf;
}
